import React, {useContext, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import UserProfileContext from "../../context/userProfile/UserProfileContext";
import Loader from "../loader/Loader";

export default function PrivateRoute({accessTo = "", Component, ...rest}) {
  const userProfileContext = useContext(UserProfileContext);
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = userProfileContext?.state ?? null;
  const isAuthLoading = userProfileContext?.loading ?? false;

  useEffect(() => {
    if (isAuthLoading) {
      return;
    }

    if (currentUser === null) {
      navigate("/login", { state: { from: location }, replace: true });
      return;
    }

    if (accessTo && (!currentUser.role || !currentUser.role.includes(accessTo))) {
      navigate("/", { replace: true });
      return;
    }
  }, [currentUser, isAuthLoading, accessTo, navigate, location]);

  if (isAuthLoading) {
    return <Loader />;
  }

  if (currentUser === null) {
    return null;
  }

  if (accessTo && (!currentUser.role || !currentUser.role.includes(accessTo))) {
    return null;
  }

  return <Component {...rest} />;
}
